import "../css/app.css";
import LazyLoad from "vanilla-lazyload";

window.addEventListener("load", function () {

    let myLazyLoad = new LazyLoad();
    // After your content has changed...
    myLazyLoad.update();
    
    import('./partials/cookie-consent.js');
    import('./partials/menus.js');

    let carousel = document.querySelector(".splide");
    if( carousel != null ) {
        import('./partials/carousel.js');
    }

    let tabs = document.querySelector(".tabs");
    if( tabs != null ) {
        import('./partials/tabs.js');
    }

    let modals = document.querySelector("[data-micromodal-trigger]");
    if( modals != null ) {
        import('./partials/modal.js');
    }

    let filters = document.querySelector("[data-js-filter]");
    if( filters != null ) {
        import('./partials/filters.js');
        import('./partials/infinate-scroll.js');
    }

    let transitions = document.querySelector("[data-barba]");
    if( transitions != null ) {
        import('./partials/transitions.js');
    }

    let youtubeVideo = document.querySelector(".video-youtube");
    let vimeoVideo = document.querySelector(".video-vimeo");
    let jsVideo = document.querySelector("[data-js-play]");
    if( youtubeVideo != null || vimeoVideo != null || jsVideo != null ) {
        import('./partials/video.js');
    }

    let gsapElement = document.querySelector(".gsap");
    if( gsapElement != null ) {
        import('./partials/animation.js');
    } 

    //Inject svgs into ckeditor styles
    let underlines = document.querySelectorAll('.svg-underline');
    let largeUnderlines = document.querySelectorAll('.svg-underline-large');
    let circled = document.querySelectorAll('.svg-circle');

    function createSVG(element, svgHash) {
        let svgElem = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        
        let useElem = document.createElementNS('http://www.w3.org/2000/svg', 'use');
        useElem.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', svgHash);

        svgElem.appendChild(useElem);
        element.appendChild(svgElem);
    }

    underlines.forEach( (underline) => {
        createSVG(underline, "#underline");
    });

    largeUnderlines.forEach( (underline) => {
        createSVG(underline, "#underline-large");
    });

    circled.forEach( (circle) => {
        createSVG(circle, "#circle-sketch");
    });

    //Crosslinks hover
    const crosslinks = this.document.querySelectorAll(".crosslinks-links");
    let crosslinkDescription = this.document.querySelector(".crosslink-description");

    crosslinks.forEach((crosslink) => {
        const links = crosslink.querySelectorAll("a");

        crosslink.addEventListener("mouseout", function() {
            let description = crosslinkDescription.dataset.description;

            if( description != null && description.length > 0 ) {
                crosslinkDescription.innerText = description;
            }
        })

        links.forEach((link) => {
            // console.log();
            link.addEventListener("mouseover", function(){
                crosslinkDescription.innerText = link.dataset.description;
            })
        }) 
    })
});

// import { createApp, defineAsyncComponent, ref } from 'vue';

// import Items from "./components/CoLabItems.vue";

// const app = createApp({
//   delimiters: ['${', '}'],

//   components: {
//       Items
//   },
//   created() {
    
//   },
//   destroyed() {
    
//   },
//   setup() {

//   },
// });


// app.mount("#app");